import axios from 'axios'

// Interface for health card data
export interface HealthCardData {
  reader_name: string
  card_no: string
  full_name: string
  id_no: string
  birth_date: string
  birth_date_timestamp: string
  sex: string
  issue_date: string
  issue_date_timestamp: string
}

export const healthCardService = {
  /**
   * Reads health card data from the card reader
   * Will try up to 10 different ports (7780-7789) if initial request fails
   * @returns Promise with health card data or error
   */
  readCard: async (): Promise<{ success: boolean; data?: HealthCardData; error?: string }> => {
    let port = 7780
    const maxTries = 10

    for (let attempt = 0; attempt < maxTries; attempt++) {
      try {
        const response = await axios.get<HealthCardData[]>(`http://127.0.0.1:${port}/read-card`)

        const data = response?.data?.[0]
        if (data) {
          return {
            success: true,
            data,
          }
        } else {
          throw new Error('Failed to read health card')
        }
      } catch (error) {
        // If this is the last attempt, return the error
        if (attempt === maxTries - 1) {
          if (axios.isAxiosError(error)) {
            return {
              success: false,
              error: error.message,
            }
          }
          return {
            success: false,
            error: 'Failed to read health card after multiple attempts',
          }
        }

        // Otherwise, increment the port and try again
        port += 1
      }
    }

    // This should not be reached due to the return in the catch block on the last attempt
    return {
      success: false,
      error: 'Failed to read health card after multiple attempts',
    }
  },
}
